import {
  API, GET, POST, PATCH, DELETE,
} from '../middleware/api';
import { API_URL } from '../config';

// Vuokra-/leasingsopimukset of one organization. Ovio staff only (admin.ovio.fi).
// `formKey` tells the reducer which form a validation error belongs to.

export function fetchLeasingAgreements(organizationId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/leasing_agreement/`,
      types: [
        'FETCH_LEASING_AGREEMENTS_REQUEST',
        'FETCH_LEASING_AGREEMENTS_SUCCESS',
        'FETCH_LEASING_AGREEMENTS_FAIL',
      ],
      params: { organization_id: organizationId },
    },
  };
}

export function createLeasingAgreement(data, formKey) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/leasing_agreement/`,
      types: [
        'CREATE_LEASING_AGREEMENT_REQUEST',
        'CREATE_LEASING_AGREEMENT_SUCCESS',
        'CREATE_LEASING_AGREEMENT_FAIL',
      ],
      data,
      params: { organization_id: data.organization },
      additionalData: { formKey },
    },
  };
}

export function updateLeasingAgreement(agreementId, data, organizationId) {
  return {
    [API]: {
      method: PATCH,
      url: `${API_URL}/uiapi/1/leasing_agreement/${agreementId}/`,
      types: [
        'UPDATE_LEASING_AGREEMENT_REQUEST',
        'UPDATE_LEASING_AGREEMENT_SUCCESS',
        'UPDATE_LEASING_AGREEMENT_FAIL',
      ],
      data,
      params: { organization_id: organizationId },
      additionalData: { formKey: agreementId },
    },
  };
}

export function deleteLeasingAgreement(agreementId, organizationId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/leasing_agreement/${agreementId}/`,
      types: [
        'DELETE_LEASING_AGREEMENT_REQUEST',
        'DELETE_LEASING_AGREEMENT_SUCCESS',
        'DELETE_LEASING_AGREEMENT_FAIL',
      ],
      params: { organization_id: organizationId },
      additionalData: { itemId: agreementId, formKey: agreementId },
    },
  };
}
